import { Box, Button, Hidden, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';

const useStyles = makeStyles({
  fullPage: {
    width: '100%',
    padding: '10px 10px 5px 10px',
  },
  titlePage: {
    padding: '0 0 5px 10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const StyledBadge = styled(Badge)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '10px 10px 5px 10px',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  '& .MuiBadge-badge': {
    right: '4px',
    top: window.innerWidth <= 768 ? '22px' : '5px',
    padding: '0 4px',
  },
}));

function Container({ title, children, buttonsRight, style = {}, badgeContent = null }) {
  const classes = useStyles();
  const isKeyboardOpen = useDetectKeyboardOpen();

  return (
    <div
      className={classes.fullPage}
      style={style}>
      <div className={classes.titlePage}>
        {typeof title === String ?
          <Typography sx={{ marginTop: 5 }}>{title}</Typography>
        : title}
        <Hidden smDown>
          <Box style={{ display: 'flex', gap: '7px' }}>
            {buttonsRight &&
              buttonsRight.map((buttons, index) => (
                <StyledBadge
                  badgeContent={buttons.badgeContent}
                  color='primary'
                  fullWidth>
                  <Tooltip
                    key={index}
                    title={buttons.tooltip}>
                    <Button
                      ref={buttons.ref}
                      {...buttons?.otherParams}
                      className={classes.buttons}
                      sx={{
                        opacity: buttons.disabled ? 0.5 : 1,
                        ...buttons?.style,
                      }}
                      disabled={buttons.disabled}
                      onClick={(e) => buttons.onClick(e)}
                      key={index}>
                      {buttons?.icon}&nbsp;{buttons?.title}
                    </Button>
                  </Tooltip>
                </StyledBadge>
              ))}
          </Box>
        </Hidden>
      </div>
      {children}
      {!isKeyboardOpen && (
        <Hidden smUp>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              position: 'absolute',
              right: 0,
              bottom: 0,
              left: 0,
              zIndex: 10,
              backgroundColor: '#F8FAFC',
            }}>
            {buttonsRight &&
              buttonsRight.map((buttons, index) => (
                <>
                  <StyledBadge
                    badgeContent={buttons.badgeContent}
                    color='primary'
                    fullWidth>
                    <Button
                      className={classes.buttons}
                      {...buttons.otherParams}
                      sx={{
                        display: 'flex',
                        flex: 1,
                        height: 70,
                        opacity: buttons.disabled ? 0.5 : 1,
                        ...buttons.style,
                      }}
                      disabled={buttons.disabled}
                      onClick={(e) => buttons.onClick(e)}
                      key={index}>
                      {buttons?.icon}&nbsp;{buttons?.title}
                    </Button>
                  </StyledBadge>
                </>
              ))}
          </div>
        </Hidden>
      )}
    </div>
  );
}

export default Container;
